import { ISelectedAttributes } from '../components/ViewEntity/interfaces'
import { getChartAPIPayloadDataSets } from '../utils/EntityAttributesUtils'
import { axiosInstanceEntity } from './axiosInstance'

export const fetchAnalysisData = async (
    orgId: string,
    viewId: string,
    dataSets: ISelectedAttributes[],
    startDate: string,
    endDate: string,
    isGuestUser: boolean,
    loginOrgId: string,
    guestUserPreferredUnit?: string,
): Promise<any> => {
    const path = isGuestUser
        ? '/coldChain/public/analysis'
        : '/coldChain/analysis'
    const chartAPIPayloadDataSets = getChartAPIPayloadDataSets(dataSets, true)

    return axiosInstanceEntity
        .post(
            path,
            {
                dataSets: chartAPIPayloadDataSets,
                mainEntityId: viewId,
                startTime: startDate,
                endTime: endDate,
                localTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            },
            {
                params: {
                    orgId,
                    loginOrgId,
                    preferredTempUnit: guestUserPreferredUnit,
                },
                isGuestUser,
            } as any,
        )
        .then((response) => {
            return response?.data || []
        })
        .catch(() => {
            return {}
        })
}
